import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import MuiBreadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { PURPLE } from './theme.js';

export function Breadcrumbs({ items }) {
    return (
        <>
            <Box sx={{ borderBottom: '1px solid #f0eaf8', py: 1.5, background: 'white' }}>
                <Container maxWidth="lg">
                    <MuiBreadcrumbs separator="›" sx={{ fontSize: '0.8rem' }}>
                        {items.map((item, index) => {
                            const isLast = index === items.length - 1;
                            return isLast ? (
                                <Typography key={index} sx={{ fontSize: '0.8rem', color: '#64748b' }}>
                                    {item.name}
                                </Typography>
                            ) : (
                                <Link
                                    key={index}
                                    href={item.path}
                                    underline="hover"
                                    sx={{ fontSize: '0.8rem', color: PURPLE }}
                                >
                                    {item.name}
                                </Link>
                            );
                        })}
                    </MuiBreadcrumbs>
                </Container>
            </Box>
        </>
    );
}
